import React, { useEffect, useState } from 'react'
import { ThemeProvider } from 'styled-components'
import { toast } from 'react-toastify'
import 'react-dates/initialize'
import { Helmet } from 'react-helmet'
import { Flex } from 'reflexbox'
import theme from 'styles/theme'
import GlobalStyle from 'styles/global'
import Loader from 'components/Loader'
import PrepaidRoutes from 'routes'
import { useUser } from 'context/user-context'
import { getUser } from 'services/auth'
import { getPostpaidUserInfo } from 'services/postpaid/partners'

toast.configure()

const Title = () => {
  return <Helmet title='Guigo TV - Parceiros Pré Pago' />
}

const App = () => {
  const { setUser } = useUser()
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const getUserInfo = async () => {
      try {
        setIsLoading(true)
        const { data } = await getUser()

        let result = {}
        if (!data.is_staff) {
          const responsePostpaid = await getPostpaidUserInfo()

          if (responsePostpaid.data.is_postpaid) {
            throw new Error('User is not a prepaid partner or staff')
          } else {
            result = { ...data }
          }
        } else {
          result = { ...data }
        }

        setUser(result)
      } catch (e) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    getUserInfo()
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Title />
      {isLoading ? (
        <Flex alignItems='center' justifyContent='center' minHeight='100vh'>
          <Loader />
        </Flex>
      ) : (
        <PrepaidRoutes />
      )}
    </ThemeProvider>
  )
}

export default App
